import React from 'react'

export default function Skill({work,removeWork,id}) {
	return (
		<>
			<li className="details-list-item"><h3><strong>{work.company}</strong></h3>
				{removeWork && (<span className="close-icon"><button onClick={()=>removeWork(id)}><i class="far fa-trash-alt"></i></button></span>)}
				<div>
					<span className="link-style">- <em>{work.title}</em></span>
					<p>{work.desc}</p>
				</div>
			</li>
		</>
	)
}